import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import Navbar from "./common/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/cropped-Guangda_logo_footer.png";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <footer className="bg-gray-800 py-6">
      <div className="container mx-auto py-4 flex flex-col md:flex-row text-white justify-between items-center">
        <div className="flex items-center">
          <a href="/" onClick={handleLogoClick}>
            <img src={logo} alt="logo" className="h-12 w-auto mr-2" />
          </a>
        </div>
        <Navbar color="text-white" />
        <div className="flex flex-col space-y-2 w-[80%] md:w-1/4 text-left mt-5">
          <div className="flex items-center space-x-2">
            <FaPhoneAlt />
            <span>
              <Link to="tel:+6583559501">+65-83559501</Link>
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <FaEnvelope />
            <span>
              <Link to="mailto:sales@guangda.sg">sales@guangda.sg</Link>
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <FaMapMarkerAlt />
            <span>12, Hoy Fatt Road, Bryton House, #06-01 room 13, 159506</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
